import { create } from 'zustand/react';
import { AddItemsState } from './AddItemsState';

const initState: Pick<AddItemsState, 'selectedItems' | 'activeStep'> = {
  selectedItems: undefined,
  activeStep: 'FIND_ITEMS',
};

export const useAddItemsStore = create<AddItemsState>((set) => ({
  ...initState,

  setSelectedItems: (selectedItems) =>
    set({
      selectedItems,
    }),

  setActiveStep: (step) => set({ activeStep: step }),
  resetState: () => set(initState),
}));
